import script from "./SceletonNewsSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./SceletonNewsSlider.vue?vue&type=script&setup=true&lang=js"

import "./SceletonNewsSlider.vue?vue&type=style&index=0&id=6658a8eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6658a8eb"]])

export default __exports__